export default __webpack_public_path__ + "static/media/Shot_23.0000.bbb74e08.png";